<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Icons/Outline/chevron-left">
<path id="Vector" d="M15 18L9 12L15 6" stroke="#0033A1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
